import { XIcon } from 'lucide-react'
import React from 'react'

interface Ipros{
  children:any,
  toggleSlider:boolean,
  onClose:()=>void
}

const MobileSlider:React.FC<Ipros> = ({children,toggleSlider,onClose}) => {
  return (
    <div 
      data-testid="mobile-slider"
      className={`fixed duration-300 ease-in  z-[9] inset-0 backdrop-blur-xs bg-[#444444BD] ${toggleSlider ? 'block':'hidden'}`}
    >
      <div data-testid="main-container" className='flex h-full flex-col justify-end'>
        <div 
          data-testid="close-button-container" 
          className='flex justify-center w-full mb-[24px]' 
          onClick={onClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onClose();
            }
          }}
          role="button"
          tabIndex={0}
        >
          <XIcon 
            data-testid="close-button"
            className="rounded-[50%] h-[36px] w-[36px] p-[8px] bg-[#fff]" 
          />
        </div>
        <div data-testid="content-container" className='min-h-[200px] w-full max-h-[90%] bg-[#fff] rounded-t-3xl p-[20px] overflow-auto'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default MobileSlider